import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@makeably/creativex-design-system';
import Asset from 'components/internal/review/Asset';
import PostInfoSection, {
  getSections,
  getTopSections,
} from 'components/internal/review/PostInfoSection';
import styles from './PostInfo.module.css';

export const propTypes = {
  checkId: PropTypes.number.isRequired,
  creativeUrl: PropTypes.string,
  isVideo: PropTypes.bool,
  onAssetReady: PropTypes.func,
  postUrl: PropTypes.string,
};

const defaultProps = {
  creativeUrl: undefined,
  isVideo: undefined,
  onAssetReady: undefined,
  postUrl: undefined,
};

function renderPostLink(postUrl) {
  if (!postUrl) return null;

  return (
    <a href={postUrl} rel="noreferrer" target="_blank">
      <Icon color="grey" name="externalLink" />
    </a>
  );
}

function renderDownloadLink(creativeUrl) {
  if (!creativeUrl) return null;

  return (
    <a href={creativeUrl} rel="noreferrer" target="_blank">
      <Icon color="grey" name="download" />
    </a>
  );
}

function renderSections(sections) {
  return sections.map(({
    content,
    header,
    isInitiallyOpen,
  }) => (
    <PostInfoSection
      key={header}
      content={content}
      header={header}
      isInitiallyOpen={isInitiallyOpen}
    />
  ));
}

function PostInfo(props) {
  const {
    checkId,
    creativeUrl,
    isVideo,
    onAssetReady,
    postUrl,
  } = props;

  const topSections = useMemo(() => (
    getTopSections(props)
  ), [props]);

  const sections = useMemo(() => (
    getSections(props)
  ), [props]);

  return (
    <div className={styles.main}>
      <div className="u-flexColumn u-gap-16">
        { renderSections(topSections) }
        <Asset
          checkId={checkId}
          isVideo={isVideo}
          sourceUrl={creativeUrl}
          onAssetReady={onAssetReady}
        />
        <div className="u-flexRow u-justifyCenter u-alignCenter u-gap-16">
          { renderPostLink(postUrl) }
          { renderDownloadLink(creativeUrl) }
        </div>
        { renderSections(sections) }
      </div>
    </div>
  );
}

PostInfo.propTypes = propTypes;
PostInfo.defaultProps = defaultProps;

export default PostInfo;
